import React, { useState, useEffect } from "react";
import goldIcon from "../../../../assets/icons/asset-icons/gold.svg";
import TransactionTypeBadge from "../../../pages/MainScreens/Transactions/TransactionTypeBadge/TransactionTypeBadge";
import Button from "../../Button/Button";
import Modal from "../Modal/Modal";
import styles from "../OrderDetails/OrderDetails.module.scss";
import {
  getTransactionDetailsAction,
  getInvoiceDownloadAction,
} from "../../../../features/user/userSlice";
import { useDispatch } from "react-redux";
import { format } from "date-fns";
import { formatPrice } from "../../../../utils/utils";
import { CSVLink } from "react-csv";
import Tooltip from "../../Tooltip/Tooltip";
import CopyBtn from "../../CopyBtn/CopyBtn";


const OrderDetailsCompleted = ({ show, handleClose, orderId, csv = null }) => {
  const dispatch = useDispatch();

  const [transactionDetails, setTransactionDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [exportFileName, setExportFileName] = useState("");
  const getDetails = async () => {
    setLoading(true);
    try {
      const dataObj = {
        transactionId: orderId.transactionId,
        orderId: orderId.orderId,
      };
      const response = await dispatch(getTransactionDetailsAction(dataObj));
      if (response.status === 200) {
        setTransactionDetails(response?.data?.data[0]);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  // const getExportList = async () => {
  //   setLoading(true);
  //   try {
  //     const dataObj = {
  //       orderId: orderId.orderId,
  //     };
  //     const res = await dispatch(getInvoiceDownloadAction(dataObj));

  //     if (res?.status === 200) {
  //       // filtering data for csv
  //       const downloadData = res?.data?.data?.list?.map((item) => ({
  //         // ...item,
  //         // UserId: item.user_uid,
  //         // Username: item.username,
  //         // Customer: item.first_name + " " + item.last_name,
  //         // Email: item.email,
  //         // Quantity: item.totalQuantity,
  //         // Price: Number(item.price).toFixed(2),
  //         // // Asset: item?.name,
  //         // Created_Date: format(new Date(item?.created_at), "dd MMM yyyy"),
  //       }));
  //       setCsvData(downloadData);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching invoice data: ", error);
  //   }
  // };

  useEffect(() => {
    if (show) {
      getDetails();
      // getExportList();
    } else {
      // setCsvData([]);
    }
  }, [show]);

  const handleDownload = async () => { };

  return (
    <Modal
      show={show}
      handleClose={handleClose}
      className={styles.order_details}
      title="Order Details"
      btntitle="Download"
      exportFileName={"TokenOverviewList.csv"}
    >
      {/* <CSVLink data={csvData} filename={exportFileName}>
        <div className={styles.button_container}>
          <Button className={styles.continue_btn} onClick={handleDownload}>
            Download
          </Button>
        </div>
      </CSVLink> */}

      <ul>
        <li>
          <h6>Order Id:</h6>
          <h6>
            <Tooltip
              icon={<span>{transactionDetails?.order_id}</span>}
              content={
                <>
                  <CopyBtn text={transactionDetails?.order_id} />{" "}
                  {transactionDetails?.order_id}
                </>
              }
            />
          </h6>
        </li>
        <li>
          <h6>Status:</h6>
          <h6>
            <TransactionTypeBadge type="green">
              {transactionDetails?.status?.toLowerCase()}
            </TransactionTypeBadge>
          </h6>
        </li>
        <li>
          <h6>Price:</h6>
          <h6>${formatPrice(Number(transactionDetails?.price))}</h6>
          {/* {Number(productData?.quantity).toFixed(0) || 0} */}
        </li>
      </ul>
      {/* <ul>
        <li>
          <h6>From:</h6>
          <h6>Gold STBL</h6>
        </li>
        <li>
          <h6>To:</h6>
          <h6></h6>
        </li>
        <li>
          <h6>Total: </h6>
          <h6>${Number(transactionDetails?.price)?.toFixed(2)}</h6>
        </li>
      </ul> */}
      <ul>
        <li>
          <h6>Payment method:</h6>
          <h6>
            {transactionDetails?.payment_from === "Other"
              ? "Fiat"
              : transactionDetails?.payment_from === "Crypto"
                ? `${transactionDetails?.payment_from} (${transactionDetails?.payment_crypto_coin})`
                : transactionDetails?.payment_from}
            {/* <img src={goldIcon} alt="Gold-stbl" /> */}
            {/* {transactionDetails?.order_redemption_tracking?.payment_method} */}
          </h6>
        </li>
        <li>
          <h6>Date:</h6>
          <h6>
            {transactionDetails?.created_at &&
              format(new Date(transactionDetails?.created_at), "dd MMM, yyyy")}
          </h6>
        </li>
      </ul>
      {/* <Button className={styles.continue_btn} onClick={handleClose} fluid>
        Continue
      </Button> */}
    </Modal>
  );
};

export default OrderDetailsCompleted;
